import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

type UnauthorizedProps = {
  logout: () => void;
  supportEmail: string;
};

export function Unauthorized({ logout, supportEmail }: UnauthorizedProps) {
  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100vh"
    >
      <LockOutlinedIcon sx={{ fontSize: 80, opacity: 0.6 }} />
      <Typography variant="h4">Unauthorized</Typography>
      <Typography>
        You do not have the required permissions to access this application.
      </Typography>
      <Typography>
        If you need access, please contact support:{" "}
        <Link variant="inherit" href={`mailto:${supportEmail}`}>
          {supportEmail}
        </Link>
      </Typography>
      <Button variant="contained" size="large" onClick={logout}>
        Logout
      </Button>
    </Stack>
  );
}
